import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleOne from '../components/ArticleOne'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleOne)
